export default __webpack_public_path__ + "static/media/market2.6c5cb807.jpg";